import { Skiptrace as Domain } from 'features/Skiptrace/domain/Skiptrace.domain'
import { getSkiptraceFundsInfo } from 'features/Skiptrace/infra/remote/getSkiptraceFundsInfo/getSkiptraceFundsInfo'

export const refreshSkiptraceFundsInfo = async (
  payload: Domain.GetSkiptraceFundsInfoPayload,
): Promise<Domain.GetSkiptraceFundsInfoResult> =>
  await getSkiptraceFundsInfo(payload)
